import axios from 'axios';
import {
  LOGIN_GET_LINE_ITEMS_BEGIN,
  LOGIN_GET_LINE_ITEMS_SUCCESS,
  LOGIN_GET_LINE_ITEMS_FAILURE,
  LOGIN_GET_LINE_ITEMS_DISMISS_ERROR,
} from './constants';

export function getLineItems(args = {}) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_GET_LINE_ITEMS_BEGIN,
    });
    const { estimateFeatureId } = args;
    // console.log("agrs................", args);
    // const token = process.env.REACT_APP_TOKEN;
    const options = {
      headers: {
        // 'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}line-items/${estimateFeatureId}`,
        options,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: LOGIN_GET_LINE_ITEMS_SUCCESS,
            data: res.data,
          });
          resolve(res);
          // console.log("action data for getlineitems", res);
        },
        (err) => {
          dispatch({
            type: LOGIN_GET_LINE_ITEMS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetLineItemsError() {
  return {
    type: LOGIN_GET_LINE_ITEMS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_GET_LINE_ITEMS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLineItemsPending: true,
        getLineItemsError: null,
      };

    case LOGIN_GET_LINE_ITEMS_SUCCESS:
      // The request is success
      return {
        ...state,
        getLineItemsPending: false,
        getLineItemsError: null,
        estimateFeatureData: action.data,
      };

    case LOGIN_GET_LINE_ITEMS_FAILURE:
      // The request is failed
      return {
        ...state,
        getLineItemsPending: false,
        getLineItemsError: action.data.error,
      };

    case LOGIN_GET_LINE_ITEMS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getLineItemsError: null,
      };

    default:
      return state;
  }
}
